import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import coupon from "assets/images/icons/coupon.svg";
import info2 from "assets/images/icons/info2.svg";
import usedCoupon from "assets/images/icons/usedCoupon.svg";
import redemption from "assets/images/icons/redemption.svg";
import riyalGray from "assets/images/icons/riyalGray.svg";
import redemptionRateTooltip from "assets/images/redemptionRateTooltip.png";
import {
  DashboardCouponIcon,
  RedemptionRateIcon,
  UsedCouponIcon,
} from "components/common/SVGIcons";

const Coupons = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const { brandInfo } = useSelector((state) => state.auth);
  const { primaryColor } = brandInfo?.theme?.themeColors  || {};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <Col lg={6}>
      <div className="inner_section">
        <div className="title_section">
          <DashboardCouponIcon color={primaryColor} />
          <h2 className="fs_20 text_black">{t("Coupons")}</h2>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <UsedCouponIcon color={primaryColor} />
            <h2 className="fs_14 text_black mt-2">{t("Used Coupons")}</h2>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.usedCoupons?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
            <p className="text_dark_gray fs_12">{t("Value of coupons:")}</p>
            <p className="text_dark_gray fs_12 mt-0">
              <img
                src={riyalGray}
                alt="riyal"
                className="mx-1"
                width={10}
                height={11}
              />
              {overviewDashboard?.customers?.usedCouponsRevenue?.toLocaleString(
                "en-US"
              )}
            </p>
          </div>
          <div className="single_item">
            <RedemptionRateIcon color={primaryColor}/>
            <div className="g_between position-relative" ref={tooltipRef}>
              <h2 className="fs_14 text_black mt-2">
                {t("Redemption Rate for Coupons")}
              </h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => setShowTooltip(!showTooltip)}
              />
              {showTooltip && (
                <img
                  src={redemptionRateTooltip}
                  width={500}
                  height={537}
                  alt="info"
                  className="c_p tooltip_img redemption_tooltip"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.redemptionRate?.toLocaleString(
                  "en-US"
                )}
                %
              </h2>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default Coupons;
